module.exports = __webpack_public_path__ + "img/0Q3A5801_L_Wood_MockedUp.7342d829.jpg";